import React, { useState } from 'react';
import { Container, Grid } from '@material-ui/core';
import { JobType } from 'components/form/jobTypes';
import { useStyle } from './sign-up.style';
import { EmployerRegistrationForm, JobseekerRegistrationForm } from '../../../components/form/auth/sign-up';

export const SignUp: React.FC = () => {
    const [jobType, setJobType] = useState('jobseeker');

    const classes = useStyle();

    return (
        <Container component="main" maxWidth={false} className={classes.container}>
            <div className={classes.paper}>
                <Grid style={{ marginBottom: '10px' }} container>
                    <Grid item container xs={12}>
                        <JobType jobType={jobType} setJobType={setJobType} />
                    </Grid>
                </Grid>
                {jobType === 'jobseeker' ? (
                    <JobseekerRegistrationForm classes={classes} />
                ) : (
                    <EmployerRegistrationForm classes={classes} />
                )}
            </div>
        </Container>
    );
};
